import { Row } from 'react-bootstrap'
import styled from 'styled-components'

export const CalendarWrapper = styled(Row).attrs({
	className: 'calendar',
})`
  .fc {
    background-color: transparent;

    th {
      border: 0;
      padding: 0;
    }

    thead {
      box-shadow: 0 5px 19px -7px rgba(141, 141, 141, 0.25);
    }

    .fc-timeline-slot-lane {
      //width: 3rem;
      border-right: 0;
      border-left: 0;

      &.fc-day-sat,
      &.fc-day-sun {
        background-color: rgba(240, 243, 247, 1);
      }

      &.fc-holiday {
        position: relative;
        background-color: rgba(255, 241, 243, 1);
      }
    }

    // resourceAreaHeaderContent
    .fc-datagrid-header .fc-datagrid-cell-frame {
      display: block;
    }

    .fc-scrollgrid-section {
      .fc-datagrid-cell-cushion {
        height: 72px;
        &.fc-scrollgrid-sync-inner {
        }
      }
    }

    .fc-timeline-slot-cushion {
      //width: 3.5rem;
      display: flex;
      padding: 0;
      height: 100%;
      color: inherit;
      text-decoration: none;

      &.fc-scrollgrid-sync-inner {
        //height: 5rem;
      }
    }

    .fc-timeline-slot-frame {
      width: 100%;
      display: block;
    }

    td.fc-day-today {
      background-color: rgba(242, 238, 249, 1);
    }

    .fc-timeline-overlap-enabled .fc-timeline-lane-frame .fc-timeline-events {
      padding-bottom: 0;
    }

    .fc-timeline-event-harness {
      //height: 100%;
    }

    .fc-timeline-event {
      display: flex;
      background-color: transparent;
      height: auto;
      border: 0;
      padding: 0.75rem 0;
      margin: 0;
    }

    .fc-datagrid-cell.fc-resource {
      border-right: 0;
    }
  }

  .fc-theme-standard table,
  .fc-theme-standard td,
  .fc-theme-standard th {
    border-right: 0;
    border-color: rgba(211, 209, 205, 1);
  }

  .fc-theme-standard .fc-scrollgrid {
    border: 0;
  }
`
